export const usProd = "pro.playbackhealth.com";
export const euProd = "pro-eu.playbackhealth.com";
export const usDev = "dev-provider-pro.playback-dev.com";
export const euDev = "dev-pro-eu.playback-dev.com";
